import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { Animated, StyleProp, ViewStyle } from 'react-native';

export interface ProgressBarPointerProps {
  percentage: number;
  pointerPercentage: number;
  delay: number;
  style?: StyleProp<ViewStyle>;
}

export const ProgressBarPointer: React.FC<ProgressBarPointerProps> = ({
  percentage,
  pointerPercentage,
  delay,
  style,
}) => {
  const pointerAnimation = React.useRef(new Animated.Value(0));

  React.useEffect(() => {
    if (isNaN(pointerPercentage)) {
      return;
    }

    Animated.sequence([
      Animated.delay(delay),
      Animated.timing(pointerAnimation.current, {
        duration: 400,
        toValue: Math.min(pointerPercentage, 1),
        useNativeDriver: false,
      }),
    ]).start();
  }, [pointerPercentage, delay]);

  return (
    <Pointer
      percentage={percentage}
      style={[
        style,
        {
          left: pointerAnimation.current.interpolate({
            inputRange: [0, 1],
            outputRange: ['0%', '100%'],
            extrapolate: 'clamp',
          }),
        },
      ]}
    />
  );
};

const getMarginLeftByPercentage = (percentage: number) => {
  if (percentage > 0.95) {
    return -10;
  }
  if (percentage <= 0.05) {
    return -3;
  }
  return -6;
};
const Pointer = styled(Animated.View)<{
  percentage: number;
}>`
  position: absolute;
  background-color: ${({ theme }) => theme.color.primary};
  height: 12px;
  width: 12px;
  border-width: 2px;
  border-color: ${({ theme }) => theme.color.white};
  border-radius: 5px;
  margin-left: ${({ percentage }) => getMarginLeftByPercentage(percentage)}px;
  margin-top: -1px;
  align-self: center;
`;
